import LogicOperatorForm from 'modules/core/components/MultiFilters/Forms/LogicOperatorForm'
import MultiFilterForm from 'modules/core/components/MultiFilters/Forms/MultiFilterForm'
import SafeJSON from 'modules/core/lib/SafeJSON'
import SafeLocalStorage from 'modules/core/lib/SafeLocalStorage'

import { logicOperators } from './logicOperators'

const getLocalStorage = (localStorageKey: string) => {
  return SafeJSON.parse(SafeLocalStorage.getItem(localStorageKey, null), null)
}

const getFilters = (value: any) => {
  return value?.filters?.map((local: any) => new MultiFilterForm(local)) || []
}

const getLogicOperator = (value: any) => {
  const params = value?.logicOperator || {
    logic_operator: logicOperators.and,
  }

  return new LogicOperatorForm(params)
}

const getMultiFilters = (localStorageKey: string) => {
  const persistedValue = getLocalStorage(localStorageKey)

  return {
    filters: getFilters(persistedValue),
    logicOperator: getLogicOperator(persistedValue),
  }
}

export default getMultiFilters
